import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { FormattedMessage } from 'react-intl';

import messages from 'aurora-translations';
import styles from './styles';

function ADGMCheckbox(props) {
  const { classes, checked, onChange, name, label, disabled } = props;
  return (
    <div className={classes.checkboxContainer}>
      <FormControlLabel
        value={checked || ''}
        control={
          <Checkbox
            checked={checked}
            onChange={onChange}
            name={name}
            classes={{ root: classes.checkbox, checked: classes.checked }}
          />
        }
        label={messages[label]?.id ? <FormattedMessage {...messages[label]} /> : label}
        disabled={disabled}
      />
    </div>
  );
}

ADGMCheckbox.propTypes = {
  classes: PropTypes.object.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

ADGMCheckbox.defaultProps = {
  disabled: false,
};

export default withStyles(styles)(ADGMCheckbox);
